import React, { CSSProperties, HTMLAttributes } from "react";
import { StatusColors } from "../../../constants/statusColors";
import { useTranslatedStatus } from "../../../constants/statusTextKey";
import { EAuditStatus } from "../../../interfaces/IAudit";

interface AuditStatusLabelProps extends HTMLAttributes<HTMLDivElement> {
    as?: any;
    status: EAuditStatus,
};

export const AuditStatusLabel: React.FC<AuditStatusLabelProps> = ({
    as: CustomWrapper,
    status,
    style = {},
    ...divProps
}) => {
    const hasDraftStatus = EAuditStatus.Draft === status;

    const LABEL_STYLE: CSSProperties = {
        textTransform: "uppercase",
        fontWeight: "bold",
        fontSize: "0.7em",
        marginLeft: "0.5em",
        color: hasDraftStatus ? StatusColors[status] : "inherit",
        ...style
    };

    const Wrapper = CustomWrapper || "span";

    const label = useTranslatedStatus(status);

    return (
        <Wrapper {...divProps} style={LABEL_STYLE}> {label} </Wrapper>
    );
};
